import Vue from 'vue'
import Vuex from 'vuex'
import { signin, signout, getUserInfo, refreshAccessToken } from '@/api'

import siteNavStore from '@/components/site-nav/store'

Vue.use(Vuex)

const accessToken = localStorage.getItem('accessToken')
const refreshToken = localStorage.getItem('refreshToken')

export default new Vuex.Store({
  modules: {
    nav: siteNavStore
  },
  state: {
    accessToken,
    refreshToken,
    user: {
      _id: '',
      username: '',
      _cp: '',
      lv: 10,
      write: false,
      isAdmin: false,
      _cps: [],
      _gr: ''
    },
    isLoggedIn: false
  },
  mutations: {
    setAuthorization (state, { accessToken, refreshToken }) {
      if (accessToken) {
        localStorage.setItem('accessToken', accessToken)
        state.accessToken = accessToken
      }

      if (refreshToken) {
        localStorage.setItem('refreshToken', refreshToken)
        state.refreshToken = refreshToken
      }
    },
    setUser (state, user) {
      if (!user) return
      state.isLoggedIn = true
      Object.assign(state.user, user)
      const selectedCompany = localStorage.getItem('selectedCompany')
      const isValidCompany = user._cps.find(company => company._id === selectedCompany)

      if (selectedCompany && isValidCompany) state.user._cp = selectedCompany
      else if (state.user._cp) localStorage.setItem('selectedCompany', state.user._cp)
      else if (state.user._cps.length) {
        localStorage.setItem('selectedCompany', state.user._cps[0]._id)
        state.user._cp = localStorage.getItem('selectedCompany')
      }
    },
    selectCompany (state, _cp) {
      state.user._cp = _cp
      localStorage.setItem('selectedCompany', _cp)
      location.reload()
    }
  },
  actions: {
    async signin ({ commit }, { username, password }) {
      try {
        const { accessToken, refreshToken } = await signin(username, password)
        commit('setAuthorization', { accessToken, refreshToken })
      } catch (err) {
        throw err
      }
    },
    async signout () {
      try {
        await signout()
        localStorage.removeItem('refreshToken')
        localStorage.removeItem('accessToken')
      } catch (err) {
        throw err
      }
    },
    async initializeUser ({ commit }) {
      try {
        const user = await getUserInfo()
        if (user) commit('setUser', user)
      } catch (err) {
        throw err
      }
    },
    async refreshAccessToken ({ state, commit }) {
      try {
        const { accessToken } = await refreshAccessToken(state.refreshToken)
        if (accessToken) commit('setAuthorization', { accessToken })
      } catch (err) {
        throw err
      }
    }
  }
})
